import { render, staticRenderFns } from "./FormSelectboxIcons.vue?vue&type=template&id=a154738e"
import script from "./FormSelectboxIcons.vue?vue&type=script&lang=js"
export * from "./FormSelectboxIcons.vue?vue&type=script&lang=js"
import style0 from "./FormSelectboxIcons.vue?vue&type=style&index=0&id=a154738e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports